import { SolidCircle } from './SolidCircle';
import { DashedCircle } from './DashedCircle';
import { FilledCircle } from './FilledCircle';
import { Position } from './Position';
import { RelativeRadius } from './RelativeRadius';
import { RelativePosition } from './RelativePosition';

export class CircleFactory {
    static createSolid(
        ctx: CanvasRenderingContext2D,
        x: number,
        y: number,
        radius: RelativeRadius,
        color: string,
        lineWidth: number
    ): SolidCircle {
        return new SolidCircle(ctx, new Position(x, y), radius, color, lineWidth);
    }

    static createDashed(
        ctx: CanvasRenderingContext2D,
        x: number,
        y: number,
        radius: RelativeRadius,
        color: string,
        lineWidth: number,
        dashPattern: number[]
    ): DashedCircle {
        return new DashedCircle(ctx, new Position(x, y), radius, color, lineWidth, dashPattern);
    }

    static createFilled(
        ctx: CanvasRenderingContext2D,
        relativePosition: RelativePosition,
        relativePointRadius: RelativeRadius,
        color: string
    ): FilledCircle {
        return new FilledCircle(ctx, relativePosition, relativePointRadius, color);
    }
} 
